import { GameObjects, Scene } from "phaser";

export abstract class BaseScene extends Scene {
    public viewport: GameObjects.Zone;
    public quality = 1;
    public viewportCenter: Phaser.Math.Vector2;
    public viewportTopCenter: Phaser.Math.Vector2;
    public viewportBottomCenter: Phaser.Math.Vector2;
    public viewportLeftCenter: Phaser.Math.Vector2;
    public viewportRightCenter: Phaser.Math.Vector2;
    public viewportBottomLeft: Phaser.Math.Vector2;
    public viewportBottomRight: Phaser.Math.Vector2;
    private blur: any;
    private focus: any;
    private key: string | Phaser.Types.Scenes.SettingsConfig
    viewportTopLeft: any;
    viewportTopRight: any;

    constructor(config: string | Phaser.Types.Scenes.SettingsConfig) {
        super(config);
        this.key = config;
    }

    init() {
        this.viewport = new GameObjects.Zone(
            this,
            Number(this.game.config.width) / 2,
            Number(this.game.config.height) / 2,
            Number(this.game.config.width),
            Number(this.game.config.height)
        );
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, this._onShutdown, this);
        this.viewportCenter = this.viewport.getCenter();
        this.viewportTopCenter = this.viewport.getTopCenter();
        this.viewportTopLeft = this.viewport.getTopLeft();
        this.viewportTopRight = this.viewport.getTopRight();
        this.viewportBottomCenter = this.viewport.getBottomCenter();
        this.viewportLeftCenter = this.viewport.getLeftCenter();
        this.viewportRightCenter = this.viewport.getRightCenter();
        this.viewportBottomLeft = this.viewport.getBottomLeft();
        this.viewportBottomRight = this.viewport.getBottomRight();
        this.focus = this.onFocus.bind(this)
        this.blur = this.onBlur.bind(this)
        window.addEventListener("blur", this.blur)
        window.addEventListener("focus", this.focus)
    }




    onBlur() {
        this.scene.pause(this.key.toString())
    }
    onFocus() {
        this.scene.resume(this.key.toString())
    }
    update(time: number, delta: number): void {
        super.update(time, delta);
        this.viewport.setSize(
            Number(this.game.config.width),
            Number(this.game.config.height)
        );
    }

    protected _onShutdown() {
        window.removeEventListener("blur", this.blur)
        window.removeEventListener("focus", this.focus)
        this.viewport.destroy();
    }
}